<!doctype html>
<html lang="en">
  <!-- <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link
      href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap"
      rel="stylesheet" />
  </head> -->
  <body id="pdf-data" #pdfContent style="width: 100%; max-width: 600px">
    <div class="pdf-content">
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"5%"}'>
          <img
            [src]="printData?.logo"
            alt="Organization Logo"
            style="width: 100px; height: auto; object-fit: contain" />
        </div>

        <div data-pdfmake='{"width":"*", "margin": [10, 0]}'>
          <div class="desc" style="text-align: right">
            {{ printData?.orgDetail.address }}
          </div>
          <div class="address" style="text-align: right">
            {{ printData?.orgDetail.city }}, {{ printData?.orgDetail.state }},
            {{ printData?.orgDetail.country }},
            {{ printData?.orgDetail.zipCode }}
          </div>
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div class="title" data-pdfmake='{"width":"*"}'>
          {{ printData?.caseDetail.student.firstName }}
          {{ printData?.caseDetail.student.lastName }}
        </div>
        <div style="width: auto">
          <!-- <table><tr><th>Table</th><tr><tr><td>Centered</td></tr></table> -->
        </div>
        <div
          class="title"
          style="text-align: right"
          data-pdfmake='{"width":"*"}'>
          <b>Supervisor : </b>
          {{ printData?.caseDetail.supervisorName || '-' }}
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Gender</div>
          <div class="dataValue">
            <b> {{ printData?.caseDetail.student.gender }}</b>
          </div>
        </div>
        <div style="width: auto">
          <div class="datalabel">Student School</div>
          <div class="dataValue">
            <b>{{ printData?.caseDetail.student.organizationName }}</b>
          </div>
        </div>
        <div style="text-align: left" data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Date Of Birth</div>
          <div class="dataValue">
            <b>{{
              printData?.caseDetail.student.dateOfBirth ?? null
                | date: 'MM/dd/yyyy'
            }}</b>
          </div>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":178}'>
          <div class="datalabel">Behavior Screener</div>
          <div class="dataValue">
            <b>{{ printData?.assesupdatedDate | date: 'MM/dd/yyyy' }}</b>
          </div>
        </div>
        <div data-pdfmake='{"width":"auto"}'>
          <div class="datalabel">Notes</div>
          <div class="dataValue">
            <b>{{ printData?.caseDetail.note || 'Nothing Entered' }}</b>
          </div>
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <div style="width: auto">
        <img
          [src]="printData?.chartImage"
          alt="Chart Image"
          style="width: 500px; height: auto"
          class="chartImage" />
        <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
        <div
          class="questionContainer"
          *ngFor="let que of printData?.behaviorAssessmentList; let i = index">
          <div class="questionHeader">
            <span class="stepIndicator">Question {{ i + 1 }}/16</span>
          </div>
          <b class="questionText">
            {{
              que.question
                | genderReplace
                  : printData?.caseDetail.student.firstName
                  : printData?.caseDetail.student.gender
            }}
          </b>
          <ul>
            <li
              *ngFor="let item of que.functionalAssessmentAnswers"
              [attr.data-pdfmake]="generateLI(item)"></li>
          </ul>
          <!-- <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' /> -->
        </div>
      </div>
    </div>
  </body>
</html>
